import { render, staticRenderFns } from "./litigation-stat.vue?vue&type=template&id=023282f2&scoped=true"
import script from "./litigation-stat.vue?vue&type=script&lang=js"
export * from "./litigation-stat.vue?vue&type=script&lang=js"
import style0 from "./litigation-stat.vue?vue&type=style&index=0&id=023282f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023282f2",
  null
  
)

export default component.exports